import React from 'react';

// Original, code-native game character. Decorative only: no answer glyphs,
// pointer handling, brand-mark replacement or raster/OCR content.
export default function PencilBuddy({ happy = false }) {
  return <svg className={`dyw-pencil${happy ? ' dyw-pencil-happy' : ''}`} viewBox="0 0 112 144" fill="none" aria-hidden="true" focusable="false">
    <ellipse cx="57" cy="135" rx="31" ry="5" fill="#57318b" opacity=".12" />
    <g className="dyw-pencil-body" transform="rotate(12 56 72)">
      <path d="M35 67Q14 58 15 43M77 66Q92 51 98 55" stroke="#7040ad" strokeWidth="7" strokeLinecap="round" />
      <path d="M34 29Q34 9 56 9Q78 9 78 29V39H34Z" fill="#f49abc" stroke="#713b8b" strokeWidth="2.5" />
      <path d="M43 25Q44 16 54 16" stroke="#fff" strokeWidth="4" strokeLinecap="round" opacity=".7" />
      <path d="M34 38H78V103L56 131L34 103Z" fill="#ffdb68" stroke="#77502f" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M66 40H77V102L65 117Z" fill="#f5b747" />
      <path d="M40 46V95" stroke="#fff0ad" strokeWidth="6" strokeLinecap="round" />
      <path d="M34 29H78V45H34Z" fill="#9564d1" stroke="#613496" strokeWidth="2.5" />
      <path d="M35 101L56 131L77 101L66 106L56 101L46 106Z" fill="#ffedd0" stroke="#77502f" strokeWidth="2" strokeLinejoin="round" />
      <path d="M49 121L56 131L64 121Q57 116 49 121Z" fill="#483452" />
      {happy ? <g stroke="#483452" strokeWidth="3" strokeLinecap="round"><path d="M43 65Q47 59 51 65M61 65Q65 59 69 65" /><path d="M49 76Q56 86 63 76Z" fill="#714172" /></g>
        : <g fill="#483452"><ellipse cx="47" cy="65" rx="3" ry="4" /><ellipse cx="65" cy="65" rx="3" ry="4" /><path d="M50 76Q56 82 62 76" stroke="#483452" strokeWidth="2.5" strokeLinecap="round" /></g>}
      <ellipse cx="42" cy="73" rx="5" ry="3" fill="#f29796" /><ellipse cx="71" cy="73" rx="5" ry="3" fill="#f29796" />
    </g>
    <path d="M92 17L95 24L102 27L95 30L92 37L89 30L82 27L89 24Z" fill="#98c86b" stroke="#588143" strokeWidth="1.5" />
    <circle cx="14" cy="99" r="5" fill="#8bc9e5" />
  </svg>;
}
